import React from 'react';
import { FaCheckCircle, FaUserCheck, FaExclamationTriangle } from 'react-icons/fa';
import { useTranslation } from "react-i18next";
import AnimateOnScroll from './AnimateOnScroll';

const Details = () => {
    const { t } = useTranslation();

    const tiers = [
        { icon: <FaCheckCircle size={20} />, color: '#00C9B1', key: 'tier1' },
        { icon: <FaUserCheck size={20} />, color: '#709CFF', key: 'tier2' },
        { icon: <FaExclamationTriangle size={20} />, color: '#f59e0b', key: 'tier3' },
    ];

    return (
        <section className="py-20 bg-white" id="human-in-the-loop">
            <div className="container">
                <AnimateOnScroll>
                    <div className="text-center mb-6 max-w-2xl mx-auto">
                        <p className="t-h1">{t("Details.label")}</p>
                        <h2 className="t-h2">{t("Details.title")}</h2>
                        <p style={{ color: '#6b7280', lineHeight: 1.7, fontSize: '0.95rem' }}>{t("Details.intro")}</p>
                    </div>
                </AnimateOnScroll>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-8">
                    {tiers.map((item, key) => (
                        <AnimateOnScroll key={key} animation="fadeUp" delay={key * 80}>
                            <div
                                className="p-6 rounded-2xl border text-center transition-all duration-300 hover:shadow-md h-full"
                                style={{ borderColor: '#e5e7eb', background: '#fff' }}
                            >
                                <div
                                    className="w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto"
                                    style={{ background: `${item.color}1a`, color: item.color }}
                                >
                                    {item.icon}
                                </div>
                                <h3
                                    className="font-bold mb-1"
                                    style={{
                                        fontFamily: '"Wix Madefor Display", sans-serif',
                                        fontSize: '1rem',
                                        color: '#010C66',
                                    }}
                                >
                                    {t(`Details.${item.key}.title`)}
                                </h3>
                                <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>{t(`Details.${item.key}.subtext`)}</p>
                            </div>
                        </AnimateOnScroll>
                    ))}
                </div>

                <AnimateOnScroll animation="fadeUp" delay={200}>
                    <p className="text-center max-w-xl mx-auto" style={{ color: '#9ca3af', fontSize: '0.875rem' }}>
                        {t("Details.outro")}
                    </p>
                </AnimateOnScroll>
            </div>
        </section>
    );
};

export default Details;
